import type { ReactElement, ReactNode } from "react";

// THE confirmation pattern for destructive/committing actions (extracted from
// the consent e-signature modal). Don't use window.confirm (unstylable,
// blocks the event loop) or ad-hoc modals — render this.
export function ConfirmDialog({
  title,
  children,
  confirmLabel,
  busyLabel,
  cancelLabel = "Cancel",
  busy = false,
  danger = false,
  error = null,
  confirmDisabled = false,
  wide = false,
  onConfirm,
  onCancel,
}: {
  title: string;
  children: ReactNode;
  confirmLabel: string;
  busyLabel?: string;
  cancelLabel?: string;
  busy?: boolean;
  danger?: boolean;
  error?: string | null;
  /** Gate the confirm button on a condition inside the dialog (e.g. a
   * certification checkbox) without faking `busy` — cancel stays usable. */
  confirmDisabled?: boolean;
  /** Document-review dialogs (the consent certification step) need reading
   * room — near-full-width card instead of the compact confirm size. */
  wide?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}): ReactElement {
  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label={title}>
      <div className={wide ? "modal-card modal-card-wide" : "modal-card"}>
        <h3>{title}</h3>
        {children}
        {error ? <p className="form-error">{error}</p> : null}
        <div className="modal-actions">
          <button className="btn-ghost" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            className={danger ? "btn-primary-glow btn-danger" : "btn-primary-glow"}
            onClick={onConfirm}
            disabled={busy || confirmDisabled}
          >
            {busy ? (busyLabel ?? `${confirmLabel}…`) : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
